import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Chip,
  Box,
  styled,
  useMediaQuery,
  useTheme,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

// Responsive CompanyLogo with dynamic sizing
const CompanyLogo = styled(Box)(({ theme }) => ({
  minWidth: "124px",
  minHeight: "124px",
  maxWidth: "124px",
  maxHeight: "124px",
  background:
    "linear-gradient(135deg, rgba(0, 23, 231, 0.5) -54.69%, rgba(255, 204, 248, 0.5) 66.41%)",
  borderRadius: 29,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: "0.75rem",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    minWidth: "80px",
    minHeight: "80px",
    maxWidth: "80px",
    maxHeight: "80px",
    borderRadius: 20,
  },
}));

const getTimeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);
  const diffInWeeks = Math.floor(diffInDays / 7);
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInSeconds < 60) return { key: "justNow", count: 0 };
  if (diffInMinutes < 60) return { key: "minutesAgo", count: diffInMinutes };
  if (diffInHours < 24) return { key: "hoursAgo", count: diffInHours };
  if (diffInDays < 7) return { key: "daysAgo", count: diffInDays };
  if (diffInWeeks < 4) return { key: "weeksAgo", count: diffInWeeks };
  if (diffInMonths < 12) return { key: "monthsAgo", count: diffInMonths };
  return { key: "yearsAgo", count: diffInYears };
};

const JobCard = ({ job }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation();

  const timeAgo = getTimeAgo(job.date);
const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    console.log("job--:", job);
  }, [job]);
  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        border: "1px solid #D9D9D9",
        borderRadius: { xs: "20px", md: "40px" },
        boxShadow: "none",
        padding: { xs: "15px", sm: "20px", md: "30px" },
        marginBottom: { xs: 4, sm: 6, md: 8 },
        transition: "all 0.3s ease",
      }}
    >
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {/* Company Logo and Job Info Section */}
        <Grid item xs={12}>
          <Grid container spacing={{ xs: 2, sm: 3 }} alignItems="flex-start">
            {/* Company Logo */}
            <Grid
              item
              xs={12}
              sm={3}
              md={2}
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
              }}
            >
              <CompanyLogo />
            </Grid>

            {/* Job Title and Info */}
            <Grid item xs={12} sm={9} md={8}>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: { xs: "20px", sm: "22px", md: "24px" },
                  lineHeight: "130%",
                  color: "#000000",
                  paddingBottom: { xs: 1, sm: 2 },
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                {job.title}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "column" },
                  alignItems: { xs: "center", sm: "flex-start" },
                  gap: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "100%",
                    color: "#00000080",
                  }}
                >
                  {t(`jobCard.timeAgo.${timeAgo.key}`, {
                    count: timeAgo.count,
                  })}
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "100%",
                    color: "#00000080",
                  }}
                >
                  {job.company}
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "100%",
                    color: "#00000080",
                  }}
                >
                  {job.localisation}
                </Typography>
              </Box>
            </Grid>

            {/* Expiry Chip */}
            <Grid
              item
              xs={12}
              sm={12}
              md={2}
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-end" },
                alignItems: "center",
                mt: { xs: 1, md: 0 },
              }}
            ></Grid>
          </Grid>
        </Grid>

        {/* Job Description */}
        <Grid item xs={12} sx={{ mt: { xs: 1, md: 2 } }}>
          {/* <Typography sx={{
                        fontWeight: 400,
                        fontSize: { xs: "13px", sm: "14px" },
                        lineHeight: { xs: "22px", sm: "26px" },
                        fontFamily: "Poppins, sans-serif",
                        color: '#000000',
                        textAlign: { xs: 'center', sm: 'left' },
                    }}
                    dangerouslySetInnerHTML={{ __html: job.description }}>
                           

                    </Typography> */}
          <Typography
            variant="body2"
            sx={{
            //   mb: isMobile ? 1.5 : 2,
              color: "#000000",
              fontSize: { xs: "13px", sm: "14px" },
              lineHeight:  { xs: "22px", sm: "26px" },
              fontFamily: "Poppins",
              fontWeight: 400,
              display: isExpanded ? "block" : "-webkit-box",
                      WebkitLineClamp: isExpanded ? "none" : 8,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            //   height: isMobile ? "48px" : "54px",

              // 🔽 Reset HTML tags inside
              "& p": {
                margin: 0,
                lineHeight:  { xs: "22px", sm: "26px" },
                fontSize:  { xs: "13px", sm: "14px" },
                fontWeight: 400,
                color: "#000000",
              },
              "& strong": {
                fontWeight: 400, 
              },
            }}
            dangerouslySetInnerHTML={{ __html: job.description }}
          />
          <Button
                              onClick={toggleExpanded}
                              sx={{
                                mt: 1,
                                p: 0,
                                minWidth: "auto",
                                color: "#1976d2",
                                fontSize: "14px",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                textTransform: "none",
                                "&:hover": {
                                  backgroundColor: "transparent",
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              {isExpanded ? t("See_less") : t("See_more")}
                            </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default JobCard;
